import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OutsourcedFeeSearchParams from './OutsourcedFeeSearchParams';
import OutsourcedFeeService from '../../../Services/OutsourcedFeeService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OutsourcedFeeItem from '../../../Domain/OutsourcedFeeItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditOutsourcedFeeWindowDescription from './EditOutsourcedFeeWindowDescription';
import CloseOutsourcedFeeWindowDescription from './CloseOutsourcedFeeWindowDescription';

class OutsourcedFeeAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OutsourcedFeeSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: null,
    };

    this.refresh = this.refresh.bind(this);
    this.startSearch = this.startSearch.bind(this);

    OutsourcedFeeItem.editFunction = this.editFunction.bind(this);
    OutsourcedFeeItem.cloneFunction = this.cloneFunction.bind(this);
    OutsourcedFeeItem.closeFunction = this.closeFunction.bind(this);
  }

  editFunction(id, item) {
    item.SurveyId = item.SurveyId ? `${item.SurveyId}//${item.ClientId}` : null;
    item.TpSurveyId = item.TpSurveyId ? `${item.TpSurveyId}//${item.ClientId}` : null;
    item.ThirdPartySource = item.ThirdPartySource === 'Any' ? null : item.ThirdPartySource;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  cloneFunction(id, item) {
    const clonedItem = { ...item, OutsourcedFeeId: null };
    clonedItem.SurveyId = clonedItem.SurveyId ? `${clonedItem.SurveyId}//${clonedItem.ClientId}` : null;
    clonedItem.TpSurveyId = clonedItem.TpSurveyId ? `${clonedItem.TpSurveyId}//${clonedItem.ClientId}` : null;
    clonedItem.ThirdPartySource = clonedItem.ThirdPartySource === 'Any' ? null : clonedItem.ThirdPartySource;
    this.setState({
      selectedItem: clonedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  closeFunction(id, item) {
    this.setState({
      selectedItem: { OutsourcedFeeId: id, EndDate: new Date() },
      shownPanel: ShownPanelsEnum.Close,
    });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem },
    });
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
    });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    return (
      <>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new OutsourcedFeeItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={EditOutsourcedFeeWindowDescription}
            errorCode='OFA90'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={EditOutsourcedFeeWindowDescription}
            errorCode='OFA101'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Close,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={CloseOutsourcedFeeWindowDescription}
            errorCode='OFA112'
          />
        )}
      </>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalIconLeft,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Left,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem }),
              label: 'Create',
              tooltip: 'Create',
              roleKey: 'outsourced_fees_edit',
              iconName: 'fa-solid fa-circle-plus',
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={OutsourcedFeeItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={OutsourcedFeeService.GetList}
          convertDBItemsFunction={OutsourcedFeeService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={OutsourcedFeeSearchParams}
          orderBy={'StartDate'}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          errorCode='OFA157'
        />
      </div>
    );
  }
}

export default OutsourcedFeeAdmin;
